


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { ReasonForPermissionForm } from '@/models/config'

// Components
import { FormCreateEditReasonForPermission } from '@/components/config'

@Component({
    name: 'ModalCreateEditReasonForPermission',
    components: {
        FormCreateEditReasonForPermission
    }
})
export default class ModalCreateEditReasonForPermission extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) reason!: ReasonForPermissionForm

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear Nuevo Motivo de Permiso'
        }
        return 'Editar Motivo de Permiso'
    }
}
